import { Button, boxShadowZ1 } from '@cycle-app/ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  ${boxShadowZ1}
  margin-left: auto;
  margin-right: auto;
`;
